module.exports = __webpack_public_path__ + "img/cardImg.73e54dfe.png";